(window as any)["GridServer"] = (window as any)["GridServer"] || {};

/* Typings to be exposed to library user */
export * from "./output/interfaces";
export { GridServer, PassThruServer } from "./output/gridserver";
// GridServerSettings should not be exposed by GridServer, but ClientSDK is already using this, should remove from the export once its removed from ClientSDK.
export {
    GridServerSettings,
    GridServerConfigData,
    ConfigureGridServerSettings,
    SessionControlConfigData,
    configureSessionControlSettings
} from "./output/settings";
export * from "./output/gserrorcode";
export {
    BrowserName,
    PlatformName,
    getPlatformDetails,
    PlatformDetails,
    DeviceModel,
    DeviceType,
    DeviceOS,
    DeviceVendor,
    NetworkType
} from "./output/dependencies";
export * from "./output/sessioncontrol";
export * from "./output/sessioncontrolutils";
